var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromoicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_34_1",
    "data-name": "Component 34 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 63.171,
    height: 63.367,
    viewBox: "0 0 63.171 63.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_858",
    "data-name": "Rectangle 858",
    width: 63.171,
    height: 63.367,
    fill: "#3ddaf3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1098",
    "data-name": "Group 1098",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M62.928,29.783c-.581-2.359-2.217-3.94-3.92-5.408-2.129-1.835-3.618-3.81-2.832-6.8,0-.738,0-1.475,0-2.214-.026-5.1-3.192-8.3-8.272-8.334-1.686-.013-3.378.071-5.057-.039A3.4,3.4,0,0,1,40.936,6.2c-1.414-1.261-2.676-2.69-4.065-3.981A7.366,7.366,0,0,0,26.349,2.2c-1.39,1.289-2.653,2.718-4.066,3.98a3.371,3.371,0,0,1-1.905.8c-1.838.108-3.688,0-5.531.049A7.7,7.7,0,0,0,7.029,14.86c-.06,2.209.513,4.663-.276,6.558S3.807,24.627,2.3,26.239A7.42,7.42,0,0,0,2.329,37c1.515,1.607,3.663,2.931,4.446,4.828s.19,4.353.258,6.563c.138,4.534,3.349,8.048,7.858,7.678a12.3,12.3,0,0,1,11.339,4.687,6.83,6.83,0,0,0,10.723.018,12.32,12.32,0,0,1,11.331-4.708c4.586.374,7.786-3.176,7.886-7.807.038-1.739-.094-3.487.053-5.214a4.314,4.314,0,0,1,.98-2.3c1.27-1.474,2.778-2.741,4.055-4.209a7.166,7.166,0,0,0,1.671-6.753m-38.9-10.824a5.051,5.051,0,1,1-5.075,5.149,5.162,5.162,0,0,1,5.075-5.149m-.7,23.6a9.773,9.773,0,0,1-1.559,1.113c-1.867-.062-2.723-1.607-1.976-2.868a5.112,5.112,0,0,1,.831-.941q9.594-9.6,19.2-19.189c.433-.431.991-.988,1.514-1.014a2.445,2.445,0,0,1,1.871.745,3.085,3.085,0,0,1,.117,2.022c-.055.349-.5.651-.795.947q-9.593,9.6-19.206,19.185m15.92,1.678a5.051,5.051,0,1,1,4.991-5.073,5.155,5.155,0,0,1-4.991,5.073",
    transform: "translate(0 0)",
    fill: "#3ddaf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M71.887,73.754a1.861,1.861,0,1,0-1.861-1.861,1.861,1.861,0,0,0,1.861,1.861",
    transform: "translate(-47.879 -47.882)",
    fill: "#3ddaf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M119.883,118.026a1.861,1.861,0,1,0,1.861,1.861,1.861,1.861,0,0,0-1.861-1.861",
    transform: "translate(-80.695 -80.698)",
    fill: "#3ddaf3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/promo.icon.7f5dbaa1f36aab5ccd6dd5ac2ac9adbc.svg";
export { ForwardRef as ReactComponent };